import { InjectionToken, WritableSignal } from "@angular/core";
import { AuthErrorData } from "../types/auth.types";
import { User } from "../models/user";

export interface AuthService {
  
  user: WritableSignal<User | null>;

  signInWithGoogle(): Promise<AuthErrorData | null>;
  signInWithEmail(email: string, password: string): Promise<AuthErrorData | null>;
  signUpWithEmail(email: string, password: string): Promise<AuthErrorData | null>;
  signOut(): Promise<AuthErrorData | null>;
  requestPasswordReset(email: string): Promise<AuthErrorData | null>;
  updatePassword(password:string): Promise<AuthErrorData | null>;
  resendConfirmationEmail(email:string): Promise<AuthErrorData | null>;
  isLoggedIn(): Promise<boolean>;
  handleLoginCallback(): Promise<AuthErrorData | null>;
  getUser(): Promise<User | null>;
  updateUser(user:Partial<User>): Promise<AuthErrorData | null>;
  deleteAccount(): Promise<AuthErrorData | null>;
}

export const AUTH_SERVICE = new InjectionToken<AuthService>('AUTH_SERVICE');